
import { TNeighborhoodsCardData } from "@/app/types/homePageTypes"
import CustomButton from "../../shared/CustomButton"
import { useNavigation } from "@/app/hooks/useNavigation"
import * as gtag from "@/app/utils/gtag"


const NeighborhoodsContentCard = ({
	data,
	noStartingPrice
}: {
	data: TNeighborhoodsCardData,
	noStartingPrice: boolean
}) => {
	const router = useNavigation()
	
	return (
		<div className="neighborhoods_content">
			<div className="neighborhoods_content_container">
				<div className="text-h5 lg:text-h4 font-minerva-regular overflow-hidden">
					<div className="move-y">{data.title}</div>
				</div>
				<p className="neighborhoods_content_desc text-[1rem] lg:text-bodyM text-oBlack-60 mb-8 font-national lg:pr-11">
					{data.desc}
				</p>
				<div className="neighborhoods_info || flex flex-wrap lg:block">
					{data?.info?.map((item, index) => (
						<div className="w-[49%] lg:w-auto flex flex-col mb-2 lg:mb-8" key={index}>
							<div className="label text-oBlack-40 font-national-bold overflow-hidden">
								<div className="move-y text-labelM">
									{item.label}
								</div>
							</div>
							{item.label === "SQM" ? (
								<div className="value overflow-hidden">
									<div className="move-y text-bodyL">
										{`${item.value} M`}<sup>2</sup>
									</div>
								</div>
							) : (
								<div className="value overflow-hidden">
									<div className="move-y text-bodyL">
										{index == 0 && !noStartingPrice
										? `EGP ${Number(item.value).toLocaleString()}`
										: (item.label?.trim() === "Unit Types" && !item.value) ? "Sold Out" : item.value}
									</div>
								</div>
							)}
						</div>
					))}
				</div>
				<div className="overflow-hidden">
					<div className="neighborhoods_buttons mt-4 flex flex-row gap-5 w-[100%] xl:w-[70%] lg:mt-0 move-y">
						{(data?.info?.[0]?.label?.trim() === "Unit Types" && data?.info?.[0]?.value) &&
							<div className="neighborhoods_button w-full lg:w-[100%]">
									<CustomButton
										action={() => {
											gtag.conversion('s22iCL--jN8bELy50MNC');
											router.push(`/neighborhoods/${data?.slug}`, "book=true");
										}}
										text="Buy now"
										hasIcon style="blue"
										disabled={false}
										customClass="w-full lg:w-[100%] !p-2 !ps-5  justify-between tracking-[0.07rem] leading-[1.5rem] pointer-events-[all]"
									/>
							</div>
						}

						<div className={`neighborhoods_button w-full ${data?.info?.[0]?.label?.trim() === "Unit Types" && data?.info?.[0]?.value?'lg:w-[100%]':'lg:w-fit'}  `}>
							<CustomButton 
							action={() => router.push(`/neighborhoods/${data?.slug}`)} 
							text="Learn More"
							disabled={false}
							hasIcon 
							style="grey" 
							customClass="w-full lg:w-[100%] !p-2 !ps-5 justify-between tracking-[0.07rem] leading-[1.5rem] pointer-events-[all]" />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}


export default NeighborhoodsContentCard